import React from 'react';
import { Typography, Box, Paper } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { formatarDataHora } from "../../utils/dateFormatters";

const styles = (theme) => ({
    historicoContainer: {
        marginTop: "1rem",
    },
    historicoEntry: {
        backgroundColor: "#EEEEEE",
        borderRadius: "5px",
        padding: "10px 15px",
        marginBottom: "10px",
        boxShadow: "none",
        '& .MuiTypography-root': {
            color: "#222222",
            fontSize: "1rem",
        }
    },
    topLine: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "6px",
        '& .MuiTypography-root': {
            fontWeight: "500",
        }
    },
    downloadLink: {
        color: "#5D6DFF",
        textDecoration: "none",
        fontWeight: "500",
        fontSize: "16px",
        "&:hover": {
            color: "#5D6DFF",
            textDecoration: "underline",
        },
    },
    noDataText: {
        color: "#6c757d",
        fontStyle: "italic",
    },
});

const EquipmentDetailsHistoryContainer = ({
    classes,
    history = [],
    downloadBasePath = "/api/laudos/",
    currentLanguage
}) => {
    return (
        <Box className={classes.historicoContainer}>
            {history.length > 0 ? (
                history.map((laudo, index) => (
                    <Paper key={index} className={classes.historicoEntry} elevation={1}>
                        <Box className={classes.topLine}>
                            <Typography variant="body2">
                                {formatarDataHora(laudo.created_at)}
                            </Typography>
                            <a
                                href={`${downloadBasePath}${laudo.nome_arquivo}`}
                                className={classes.downloadLink}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {currentLanguage.bepiService.shared.shared_equip_download_label}
                            </a>
                        </Box>
                        <Typography>
                            {laudo.nome || '---'}
                            <br />
                            {laudo.descricao || '---'}
                        </Typography>
                    </Paper>
                ))
            ) : (
                <Typography className={classes.noDataText}>
                    {currentLanguage.bepiService.shared.shared_equip_no_history_msg}
                </Typography>
            )}
        </Box>
    );
};

export default withStyles(styles)(EquipmentDetailsHistoryContainer);
